import React, { useEffect, useState } from 'react';

import Jurisdiction from './Jurisdiction';
import classnames from 'classnames';
import { component } from './styles.module.scss';
import fetchJson from 'Utils/fetchJson';

const MultiJurisdiction = (props) => {
  const { priorityGroupsSummary, jurisdictions, country } = props;

  const [usStateVaccinationData, setUsStateVaccinationData] = useState(null);

  const isUSA = country.isoAlpha2 === 'US';

  useEffect(() => {
    const fetchUsData = async() => {
      const [
        usStateVaccinationData,
      ] = await Promise.all([
        fetchJson('https://graphics.thomsonreuters.com/data/2020/coronavirus/us-covid-vaccinations/latest_data.json'),
      ]);
      usStateVaccinationData['New York'] = usStateVaccinationData['New York State'];
      setUsStateVaccinationData(usStateVaccinationData);
    };

    if (isUSA && !usStateVaccinationData) fetchUsData();
  }, [isUSA, usStateVaccinationData]);

  // console.log(usStateVaccinationData);

  return (
    <div className={classnames(component)}>
      {jurisdictions
        .filter(jurisdiction => {
          if (!isUSA) return true;
          if (!usStateVaccinationData) return false;
          return jurisdiction.name in usStateVaccinationData;
        })
        .map(jurisdiction => (
          <Jurisdiction
            usState={isUSA ? usStateVaccinationData[jurisdiction.name] : null}
            jurisdiction={jurisdiction}
            phaseProgress={priorityGroupsSummary.jurisdictions.find(s => s.name === jurisdiction.name).phaseProgress}
            key={jurisdiction.name}
          />
        ))}
    </div>
  );
};

export default MultiJurisdiction;
